import { BirdWaTemplateLang } from 'lib/enum/language-code.enum';
import { ChannelConnectionType } from 'services/Api/MessagingChannels/types';

export type WaTemplateType = {
    id: string;
    name: string;
    language: BirdWaTemplateLang;
    status: TemplateStatus;
    components: TemplateComponent[];
    projectId?: string;
    templateId?: string;
    connectionType?: ChannelConnectionType;
    variables?: WaTemplateVariable[];
};

export type WaTemplateVariable = {
    key: string;
    type: string;
};

export enum TemplateStatus {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Draft = 'DRAFT',
}

export enum BirdWaTemplateStatus {
    Draft = 'draft',
    Active = 'active',
    Inactive = 'inactive',
    Pending = 'pending',
    PendingReview = 'pendingReview',
}

export type TemplateComponent = {
    type: TemplateComponentType;
    format?: TemplateComponentFormat;
    text?: string;
    buttons: TemplateComponentButton[] | null;
    example?: TemplateExample;
};

export enum TemplateComponentType {
    Body = 'BODY',
    Header = 'HEADER',
    Footer = 'FOOTER',
    Buttons = 'BUTTONS',
}

export enum TemplateComponentFormat {
    Text = 'TEXT',
    Image = 'IMAGE',
    Document = 'DOCUMENT',
    Video = 'VIDEO',
}

export type TemplateComponentButton = {
    type: TemplateComponentButtonType;
    text: string;
    url?: string;
    phoneNumber?: string;
    example: string[] | null;
};

export enum TemplateComponentButtonType {
    PhoneNumber = 'PHONE_NUMBER',
    Url = 'URL',
    QuickReply = 'QUICK_REPLY',
}

export enum BirdTemplateBlockType {
    Text = 'text',
    ReplyAction = 'reply-action',
}

export enum TextBlockRole {
    Header = 'header',
    Body = 'body',
    Footer = 'footer',
}

type TemplateExample = {
    headerText: string[] | null;
    bodyText: string[][] | null;
    headerUrl: string[] | null;
};

export type BirdContentType = {
    locale: BirdWaTemplateLang;
    type: string | null;
    blocks: BirdBlock[];
};

export type BirdBlock =
    | {
          type: 'text';
          role: TextBlockRole | null;
          text: string;
      }
    | {
          type: 'reply-action';
          replyAction: {
              text: string;
              imageUrl: string | null;
              payload: string | null;
          };
      };

export type BirdWaTemplateType = {
    id: string;
    project: {
        id: string;
        name: string;
        activeVersionId: string | null;
    };
    status: BirdWaTemplateStatus;
    defaultLocale: string;
    contents: BirdContentType[];
    variables?: WaTemplateVariable[];
};
